import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import InfoModal from '../../../../../../features/components/Modals/InfoModalNew'
import InfoModalButtons from '../../../../../../features/components/Modals/InfoModalNew/InfoModalButtons'

import { DISAPPROVED_REASON } from '../../../../../../features/components/Modals/AskReasonModal/fields'
import { PRIMARY_BUTTON } from '../../../../../../features/components/Modals/InfoModalNew/InfoModalButtons/helpers'

import useStyles from './styles'

const FileInstancesModal = ({ isOpen, onClose, data = {}, onFilesStatusChange }) => {
  const classes = useStyles()

  const { t } = useTranslation()

  const { status, uploadedFile, [DISAPPROVED_REASON]: disapprovedReason, allFileIds } = data

  const handleStatusChange = useCallback(
    ids => {
      onFilesStatusChange({
        ids,
        status,
        disapprovedReason
      })

      onClose()
    },
    [onFilesStatusChange, status, disapprovedReason, onClose]
  )

  const updateOnlyThisFileHandler = useCallback(() => {
    // update the status of the uploaded file
    handleStatusChange([uploadedFile.id])
  }, [uploadedFile, handleStatusChange])

  const updateAllAssetsHandler = useCallback(() => {
    handleStatusChange(allFileIds)
  }, [allFileIds, handleStatusChange])

  const buttons = useMemo(
    () => [
      {
        type: 'button',
        text: t('Only this file'),
        onClick: updateOnlyThisFileHandler
      },
      {
        type: 'button',
        text: t('Apply to all'),
        solid: true,
        buttonColor: PRIMARY_BUTTON,
        onClick: updateAllAssetsHandler
      }
    ],
    [t, updateAllAssetsHandler, updateOnlyThisFileHandler]
  )

  return (
    <InfoModal
      isOpen={isOpen}
      onClose={onClose}
      modalTitle="Apply to all instances of this file"
      ModalMessage={<p>{t('Would you like to apply this status to all instances of this file?')}</p>}
      headerClassName={classes.header}
    >
      <InfoModalButtons buttons={buttons} />
    </InfoModal>
  )
}

FileInstancesModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.shape({
    status: PropTypes.string,
    uploadedFile: PropTypes.object,
    [DISAPPROVED_REASON]: PropTypes.string,
    allFileIds: PropTypes.array
  }),
  onFilesStatusChange: PropTypes.func
}

export default FileInstancesModal
